export default __webpack_public_path__ + "static/media/brand-light.012edaab.svg";